import { Box, Flex, HStack, Heading, Stack, Text } from "@chakra-ui/react";
import React from "react";
import { BiStar } from "react-icons/bi";

export default function Ratings() {
  return (
    <Stack gap={8} py={6} px={{base:2,md:10}} border="1px solid #c5c5c5" borderRadius="5px">
      <Heading fontSize={{ base: "18px", md: "24px" }} fontWeight={"semibold"}>
        Ratings
      </Heading>
      <HStack alignItems={"center"} gap={2}>
        <Text fontSize={{ base: "12px", md: "20px" }} fontWeight={"semibold"}>
          All-Time Rating 0
        </Text>
        <Flex
          color={"#ffbe5b"}
          gap={1}
          alignItems="center"
          fontSize={{ base:"16px",md: "18px", xl: "22px" }}
        >
          <BiStar  />
          <BiStar  />
          <BiStar  />
          <BiStar  />
          <BiStar  />
          <Text color="#c5c5c5">(0)</Text>
        </Flex>
      </HStack>
      <Stack fontSize={{base:"14px"}}>
        <HStack gap={1} fontWeight={"medium"}>
          <Text w="120px">5 Stars</Text>
          <Box bg="#c5c5c5" rounded="lg" p={2} w="full" />
          <Text>(0)</Text>
        </HStack>
        <HStack gap={1} fontWeight={"medium"}>
          <Text w="120px">4 Stars</Text>
          <Box bg="#c5c5c5" rounded="lg" p={2} w="full" />
          <Text>(0)</Text>
        </HStack>
        <HStack gap={1} fontWeight={"medium"}>
          <Text w="120px">3 Stars</Text>
          <Box bg="#c5c5c5" rounded="lg" p={2} w="full" />
          <Text>(0)</Text>
        </HStack>
        <HStack gap={1} fontWeight={"medium"}>
          <Text w="120px">2 Stars</Text>
          <Box bg="#c5c5c5" rounded="lg" p={2} w="full" />
          <Text>(0)</Text>
        </HStack>
        <HStack gap={1} fontWeight={"medium"}>
          <Text w="120px">1 Stars</Text>
          <Box bg="#c5c5c5" rounded="lg" p={2} w="full" />
          <Text>(0)</Text>
        </HStack>
      </Stack>
      <Stack>
        <Text fontSize={{ base: "16px", md: "20px" }} fontWeight={"semibold"}>
          Rating Breakdown
        </Text>
        <HStack alignItems={"center"} gap={2} justifyContent="space-between">
          <Text fontSize={{ base: "12px", md: "16px" }}>Communication With Seller</Text>
          <Flex
            color={"#ffbe5b"}
            gap={1}
            alignItems="center"
            fontSize={{ base: "12px", xl: "16px" }}
          >
            <BiStar  />
            <BiStar  />
            <BiStar  />
            <BiStar  />
            <BiStar  />
            <Text color="#c5c5c5">(0)</Text>
          </Flex>
        </HStack>
        <HStack alignItems={"center"} gap={2} justifyContent="space-between">
          <Text fontSize={{ base: "12px", md: "16px" }}>Service as Described</Text>
          <Flex
            color={"#ffbe5b"}
            gap={1}
            alignItems="center"
            fontSize={{ base: "12px", xl: "16px" }}
          >
            <BiStar  />
            <BiStar  />
            <BiStar  />
            <BiStar  />
            <BiStar  />
            <Text color="#c5c5c5">(0)</Text>
          </Flex>
        </HStack>
        <HStack alignItems={"center"} gap={2} justifyContent="space-between">
          <Text fontSize={{ base: "12px", md: "16px" }}>Buy Again or Recommend</Text>
          <Flex
            color={"#ffbe5b"}
            gap={1}
            alignItems="center"
            fontSize={{ base: "12px", xl: "16px" }}
          >
            <BiStar  />
            <BiStar  />
            <BiStar  />
            <BiStar  />
            <BiStar  />
            <Text color="#c5c5c5">(0)</Text>
          </Flex>
        </HStack>
      </Stack>
    </Stack>
  );
}
